import axios from 'axios';

export default axios.create({
    baseURL: `https://api.puntasanat.com/api`,
});